
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import NewOrders from "../Pages/Orders/NewOrders";
import Orders from "../Pages/Orders/Orders";
import Create from "../Pages/Orders/Create";
import OrderDetails from "../Pages/Orders/OrderDetails";
import SearchProduct from "../Pages/Products/SearchProduct";
import OrderBatteries from "../Pages/Orders/OrderBatteries";
import Vendors from "../Pages/Home/Vendors";
import Vendor from "../Pages/Home/Vendor";
import VendorsReport from "../Pages/Reports/VendorsReport";
import ReturnOrders from "../Pages/Orders/ReturnOrders";
import ROrderDetails from "../Pages/Orders/ROrderDetails";
import BOrderDetails from "../Pages/Orders/BOrderDetails";
import BOrders from "../Pages/Orders/BOrders";


const appRoutes = [
    {
        pageId : 1,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 4,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 5,
        path: "/orders",
        component: <Orders />,
    },
    {
        pageId : 6,
        path: "/orders-list/:id",
        component: <NewOrders />,
    },
    {
        pageId : 7,
        path: "/order-create",
        component: <Create />,
    },
    {
        pageId : 8,
        path: "/orders/:id",
        component: <OrderDetails />,
    },
    {
        pageId : 9,
        path: "/search",
        component: <SearchProduct />,
    },
    {
        pageId : 10,
        path: "/order-batteries/:id",
        component: <OrderBatteries />,
    },
    {
        pageId : 11,
        path: "/vendors",
        component: <Vendors />,
    },

    {
        pageId : 12,
        path: "/vendors/:id",
        component: <Vendor />,
    },

    {
        pageId : 13,
        path: "/vendors-reports",
        component: <VendorsReport />,
    },

    {
        pageId : 14,
        path: "/return-orders",
        component: <ReturnOrders />,
    },

    {
        pageId : 15,
        path: "/return-orders/:id",
        component: <ROrderDetails />,
    },
    {
        pageId : 16,
        path: "/sb-orders/:id",
        component: <BOrderDetails />,
    },
    {
        pageId: 17,
        path: "/sb-orders",
        component: <BOrders />
    }
];
export default appRoutes;